import React, { Component } from 'react';
import { Modal } from '@beef/ui-kit';
import PropTypes from 'prop-types';

export const PopupStateless = ({ children, onClose, opened }) => {
  return (
    <Modal isOpen={opened} onClose={onClose} size="s">
      {children}
    </Modal>
  );
};

PopupStateless.propTypes = {
  children: PropTypes.node,
  onClose: PropTypes.func,
  opened: PropTypes.bool,
};

/**
 * One-use popup, initially open, it can only be closed once and for good
 * For all other use cases, please refer to Stateless version
 */
export default class PopupDisposable extends Component {
  state = {
    isOpen: true,
  };

  handleClose = () => this.setState({ isOpen: false });

  render() {
    return <PopupStateless {...this.props} onClose={this.handleClose} opened={this.state.isOpen} />;
  }
}

PopupDisposable.propTypes = {
  children: PropTypes.node, // inheritedProps
  className: PropTypes.string, // inheritedProps
  wide: PropTypes.bool, // inheritedProps
};
